// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e2-a";
export var fulfillmentFormRail = "_e2-9";
export var headerTitleRow = "_e2-c";
export var orderDetailsWrapper = "_e2-7";
export var orderLinkTrigger = "_e2-2";
export var paymentInformationGrid = "_e2-h";
export var paymentSummaryColumn = "_e2-i";
export var shipmentContainer = "_e2-b";
export var shipmentDetailsMainPane = "_e2-8";
export var shipmentNavigationCard = "_e2-5";
export var shipmentNavigationRail = "_e2-3";
export var shipmentNavigationRailHeader = "_e2-4";
export var shipmentSummaryFact = "_e2-e";
export var shipmentSummaryGrid = "_e2-d";
export var shipmentSummaryMetadataRow = "_e2-f";
export var shipmentSummaryTags = "_e2-g";
export var shipmentWorkspace = "_e2-0";
export var shipmentWorkspaceContent = "_e2-6";
export var shipmentWorkspaceHeader = "_e2-1";